import { render, staticRenderFns } from "./ProjectSiteManagementRemarks.vue?vue&type=template&id=599c5a2c"
import script from "./ProjectSiteManagementRemarks.vue?vue&type=script&lang=js"
export * from "./ProjectSiteManagementRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports